import axios, { AxiosResponse } from "axios";
import { ISettings } from "../types/ISettings";
import { IReceiptData } from "../types/IReceiptData";
import { ITelephone } from "../types/ITelephone";
import { apiUrl } from "../EposConfig";
import { IReceiptRow } from "../types/IReceiptRow";
import { IPark } from "../types/IPark";
import { generateGUID } from "../helpers/Helper";
import { IReceipt } from "../types/IReceipt";

const baseConfig = {
  baseURL: apiUrl,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer ",
  },
  validateStatus: () => true,
};

export const getSettings = (token: string): Promise<ISettings | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .get("Settings", config)
    .then((response: AxiosResponse<ISettings>) => {
      return response.data;
    })
    .catch(handleError);
};

export const getTelephoneData = (
  token: string
): Promise<ITelephone[] | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .get("Telephone/Telephone", config)
    .then((response: AxiosResponse<ITelephone[]>) => {
      return response.data;
    })
    .catch(handleError);
};

export const createOrder = (
  data: IReceiptData,
  token: string
): Promise<number | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .post("Receipt/Add", data, config)
    .then((response: AxiosResponse<number>) => {
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch(handleError);
};

export const getParkedOrders = (token: string): Promise<IPark[] | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .get("Receipt/Parked", config)
    .then((response: AxiosResponse<IPark[]>) => {
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch(handleError);
};

export const parkReceipt = (
  token: string,
  description: string,
  data: string
): Promise<boolean | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;

  const d: IPark = {
    id: 0,
    uuid: generateGUID(),
    createdAt: new Date(),
    description1: description,
    description2: "",
    receiptData: data,
  };

  return axios
    .post("Receipt/Park", d, config)
    .then((response: AxiosResponse<boolean>) => {
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch(handleError);
};

export const updateReceipt = (
  token: string,
  uuid: string,
  description: string,
  data: string
): Promise<boolean | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;

  const d: IPark = {
    id: 0,
    uuid: uuid,
    createdAt: new Date(),
    description1: description,
    description2: "",
    receiptData: data,
  };

  return axios
    .post("Receipt/UpdateParked", d, config)
    .then((response: AxiosResponse<boolean>) => {
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch(handleError);
};

export const getReceipts = (
  startDate: Date,
  endDate: Date,
  token: string
): Promise<IReceipt[] | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  const dateRange = {
    start: startDate,
    end: endDate,
  };

  return axios
    .post("Receipt/Receipts", dateRange, config)
    .then((response: AxiosResponse<IReceipt[]>) => {
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch(handleError);
};

function handleError(error: any) {
  console.log("api error @ " + new Date());
  console.log(error);
  console.log(error.response);

  if (error.response) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
  } else if (error.request) {
    console.log(error.request);
  } else {
    console.log("Error", error.message);
  }
}
